import { createFileRoute, redirect } from "@tanstack/react-router";
import GeneratorSubcategoryLanding from "@/pages/GeneratorSubcategoryLanding";

// Legacy slug moved to /open-frame-generators. Redirecting on the server keeps
// crawlers from seeing a titleless client-rendered shell.
const LEGACY_SLUG_REDIRECTS: Record<string, string> = {
  "framed-generators": "/generators/category/open-frame-generators",
};

export const Route = createFileRoute("/generators/category/$slug")({
  beforeLoad: ({ params }) => {
    const target = LEGACY_SLUG_REDIRECTS[params.slug];
    if (target) throw redirect({ to: target, statusCode: 301 });
  },
  component: GeneratorSubcategoryLanding,
});
